import { PERMISSIONS } from '@baboor/baboor-models'
import { NavigationGroup } from './vendor-sidebar-model'

export const navigationGroups: NavigationGroup[] = [
    {
        label: 'vendorDashboard.sidebarVendor.groups.main',
        icon: 'pi pi-th-large',
        expanded: true,
        items: [
            {
                label: 'vendorDashboard.sidebarVendor.items.home',
                icon: 'pi-th-large',
                routerLink: '/dashboard/home',
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.calendar',
                icon: 'pi-calendar',
                routerLink: '/dashboard/calendar',
                permission: PERMISSIONS.calendar.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.appointments',
                icon: 'pi-calendar-clock',
                routerLink: '/dashboard/appointments',
                permission: PERMISSIONS.appointment.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.waitlist',
                icon: 'pi-clock',
                routerLink: '/dashboard/waitlist',
                permission: [
                    PERMISSIONS.waitlist.read,
                    PERMISSIONS.waitlist.write,
                ],
            },
        ],
    },
    {
        label: 'vendorDashboard.sidebarVendor.groups.peopleOrganization',
        icon: 'pi pi-users',
        items: [
            {
                label: 'vendorDashboard.sidebarVendor.items.clients',
                icon: 'pi-users',
                routerLink: '/dashboard/clients',
                permission: PERMISSIONS.crm.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.staff',
                icon: 'pi-briefcase',
                routerLink: '/dashboard/team',
                permission: PERMISSIONS.staff.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.organization',
                icon: 'pi-building',
                routerLink: '/dashboard/organization',
                permission: PERMISSIONS.organization.read,
            },
        ],
    },
    {
        label: 'vendorDashboard.sidebarVendor.groups.services',
        icon: 'pi pi-tag',
        items: [
            {
                label: 'vendorDashboard.sidebarVendor.items.services',
                icon: 'pi-compass',
                routerLink: '/dashboard/services',
                permission: PERMISSIONS.service.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.inventory',
                icon: 'pi-box',
                routerLink: '/dashboard/inventory',
                permission: PERMISSIONS.inventory.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.lookbook',
                icon: 'pi-images',
                routerLink: '/dashboard/lookbook',
                permission: PERMISSIONS.shop.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.marketplace',
                icon: 'pi-shopping-bag',
                routerLink: '/dashboard/marketplace',
                permission: PERMISSIONS.shop.write,
            },
        ],
    },
    {
        label: 'vendorDashboard.sidebarVendor.groups.finance',
        icon: 'pi pi-wallet',
        items: [
            {
                label: 'vendorDashboard.sidebarVendor.items.referral',
                icon: 'pi-ticket',
                routerLink: '/dashboard/referral',
                permission: PERMISSIONS.promotion.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.discounts',
                icon: 'pi-percentage',
                routerLink: '/dashboard/discounts',
                permission: PERMISSIONS.discount.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.financialDashboard',
                icon: 'pi-chart-pie',
                routerLink: '/dashboard/financial',
                permission: PERMISSIONS.finance.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.invoices',
                icon: 'pi-receipt',
                routerLink: '/dashboard/invoices',
                permission: PERMISSIONS.invoice.read,
            },
        ],
    },
    {
        label: 'vendorDashboard.sidebarVendor.groups.website',
        icon: 'pi pi-globe',
        items: [
            {
                label: 'vendorDashboard.sidebarVendor.items.manage',
                icon: 'pi-window-maximize',
                routerLink: '/dashboard/website/manage',
                permission: PERMISSIONS.shop.write,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.settings',
                icon: 'pi-sliders-v',
                routerLink: '/dashboard/website/settings',
                permission: PERMISSIONS.shop.write,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.websiteInquiries',
                icon: 'pi-inbox',
                routerLink: '/dashboard/website/inquiries',
                permission: PERMISSIONS.shop.write,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.websiteTheme',
                icon: 'pi-palette',
                routerLink: '/dashboard/website/theme',
                permission: PERMISSIONS.shop.write,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.heroBanners',
                icon: 'pi-images',
                routerLink: '/dashboard/website/banners',
                permission: PERMISSIONS.shop.write,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.googleReviews',
                icon: 'pi-star',
                routerLink: '/dashboard/website/reviews',
                permission: PERMISSIONS.shop.write,
            },
        ],
    },
    {
        label: 'vendorDashboard.sidebarVendor.groups.support',
        icon: 'pi pi-cog',
        items: [
            {
                label: 'vendorDashboard.sidebarVendor.items.settings',
                icon: 'pi-cog',
                routerLink: '/dashboard/settings',
                permission: PERMISSIONS.settings.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.feedback',
                icon: 'pi-comments',
                routerLink: '/dashboard/feedback',
                permission: PERMISSIONS.shop.read,
            },
            {
                label: 'vendorDashboard.sidebarVendor.items.documents',
                icon: 'pi-file',
                routerLink: '/dashboard/documents',
                permission: PERMISSIONS.document.read,
            },
        ],
    },
]
